/* eslint-disable */
import VariantTable from '@/Pages/Food Products/VariantPrice/VariantTable';
import { useEffect, useMemo, useState, memo } from 'react';

const TableInput = memo(({ value, onChange, className, placeholder }) => {
	const [localValue, setLocalValue] = useState(value ?? '');

	useEffect(() => {
		setLocalValue(value ?? '');
	}, [value]);

	const handleBlur = () => {
		if (localValue !== value) {
			onChange(localValue);
		}
	};

	const handleChange = (e) => {
		setLocalValue(e.target.value);
	};

	return (
		<input
			type='text'
			value={localValue}
			onChange={handleChange}
			onBlur={handleBlur}
			className={className}
			onKeyDown={(e) => ['-', '+', "'", 'e', 'E'].includes(e.key) && e.preventDefault()}
			placeholder={placeholder}
		/>
	);
});

const RenderItemsTable = (props) => {
	const {
		items = [],
		columns = [],
		colMapping = {},
		onItemsChange = () => { },
		confirmedField,
	} = props;

	// Prepare data for VariantTable with IDs and sno
	const tableData = useMemo(() => {
		return items.map((item, idx) => ({
			...item,
			id: item.id ?? item.variantId ?? item.itemId ?? idx,
			_itemKey: item.id ?? item.variantId ?? item.itemId ?? idx,
			sno: idx + 1,
		}));
	}, [items]);

	const handleInputChange = (index, key, value) => {
		const newItems = [...items];
		newItems[index] = { ...newItems[index], [key]: value };
		onItemsChange(newItems);
	};

	const firstDisplayColumnKey = useMemo(() => {
		const skip = new Set([
			'#', 'sno', 'srno', 'srNo', 'index', 'idx', 'serial',
		]);
		return columns.find((c) => !c.editable && !skip.has(c.key))?.key;
	}, [columns]);

	const resolvedCustomRowData = useMemo(() => {
		const base = {};
		columns?.forEach((col) => {
			if (col.editable) {
				base[col.key] = (row, index, colKey, absoluteIndex) => {
					const idx = absoluteIndex ?? index;
					return (
						<div className='flex items-center justify-center px-1'>
							<TableInput
								value={row[col.key] ?? ''}
								onChange={(val) => handleInputChange(idx, col.key, val)}
								className='w-full text-center rounded-md border border-amber-300 px-2 py-1.5 text-[13px] font-medium text-gray-800 shadow-sm focus:outline-none focus:ring-2 focus:ring-amber-400 focus:border-amber-400 bg-white transition-colors'
								placeholder='Enter...'
							/>
						</div>
					);
				};
			} else {
				base[col.key] = (row) => {
					const value = row[col.key] ?? row[colMapping[col.key]] ?? '-';
					if (confirmedField && col.key === firstDisplayColumnKey) {
						return (
							<div className='text-[13px] text-gray-800 text-center font-medium'>
								{value}
							</div>
						);
					}
					return (
						<div className='text-[13px] text-gray-700 text-center'>
							{value}
						</div>
					);
				};
			}
		});
		return base;
	}, [columns, tableData, colMapping, items, confirmedField, firstDisplayColumnKey, handleInputChange]);

	return (
		<div className='h-full w-full overflow-hidden'>
			<div className='h-full'>
				<VariantTable
					data={tableData}
					columns={columns}
					colMapping={colMapping}
					customRowData={resolvedCustomRowData}
					customInfoLine='No items found'
				/>
			</div>
		</div>
	);
};

export default RenderItemsTable;
